module.exports = __webpack_public_path__ + "img/symbol_11.3ee6cd42.png";